"use client";
import Image from "next/image";
import Link from "next/link";
import React, { lazy } from "react";
import { useMediaQuery } from "usehooks-ts";

const MenuDrawer = lazy(() => import("./MenuDrawer"));

const DrawerLogo = ({
  seed,
  className,
  today,
  width = 150,
  height = 50,
}: {
  seed?: bigint;
  today?: bigint;
  className?: string;
  width?: number;
  height?: number;
}) => {
  const isTrigger = useMediaQuery("(max-width: 1024px)");

  if (!isTrigger) {
    return (
      <Link href="/">
        <Image
          priority
          src="/logo4.svg"
          width={150}
          height={50}
          alt="logo"
          className="absolute top-1 left-3 z-10 select-none cursor-pointer event-none"
        />
      </Link>
    );
  }

  return (
    <div
      className={
        className
          ? className
          : "absolute top-1 left-3 z-10 select-none cursor-pointer event-none"
      }
    >
      <MenuDrawer today={today} current={seed} />
    </div>
  );
};

export default DrawerLogo;
